/**
 * AccountInfoSection Component
 * 라이더 정산정보(계좌정보) 섹션
 */
import React from 'react';
import { RiderAccountInfo, BankOption } from '../types/riderInfoDetail.types';

interface AccountInfoSectionProps {
    accountInfo: RiderAccountInfo;
    bankOptions: readonly BankOption[];
    onBankChange: (value: string) => void;
    onAccountNumberChange: (value: string) => void;
    onAccountHolderChange: (value: string) => void;
    onSave: () => void;
}

const AccountInfoSection: React.FC<AccountInfoSectionProps> = ({
    accountInfo,
    bankOptions,
    onBankChange,
    onAccountNumberChange,
    onAccountHolderChange,
    onSave
}) => {
    return (
        <div className="section-margin">
            <h3 className="section-title">정산정보</h3>
            <div className="account-info-grid">
                <div className="account-section">
                    <div className="account-label-container">
                        <div className="account-label">계좌정보 :</div>
                    </div>
                    <div className="account-input-container">
                        <select
                            className="form-input"
                            value={accountInfo.bank}
                            onChange={(e) => onBankChange(e.target.value)}
                        >
                            {bankOptions.map((bank) => (
                                <option key={bank.value} value={bank.value}>
                                    {bank.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="account-section">
                    <div className="account-label-container">
                        <div className="account-label">계좌번호 :</div>
                    </div>
                    <div className="account-input-container">
                        <input
                            type="text"
                            className="form-input"
                            value={accountInfo.accountNumber}
                            onChange={(e) => onAccountNumberChange(e.target.value)}
                            placeholder="계좌번호 입력"
                            pattern="[0-9]*"
                            inputMode="numeric"
                        />
                    </div>
                </div>

                <div className="account-section">
                    <div className="account-label-container">
                        <div className="account-label">예금주 :</div>
                    </div>
                    <div className="account-input-container">
                        <input
                            type="text"
                            className="form-input"
                            value={accountInfo.accountHolder}
                            onChange={(e) => onAccountHolderChange(e.target.value)}
                            placeholder="예금주 입력"
                        />
                    </div>
                </div>

                <button
                    className="account-save-button"
                    onClick={onSave}
                >
                    저장
                </button>
            </div>
        </div>
    );
};

export default AccountInfoSection;
